'use strict';

angular.module('uniromaLandingApp').controller('EsterniDialogController',
		['$scope', '$stateParams', '$uibModalInstance', '$window','entity', 'Esterni','CodiceFiscaleService','CategorieService','EsterniStatiSpecService','User','$q', 
	        function($scope, $stateParams, $uibModalInstance, $window,entity, Esterni, CodiceFiscaleService, CategorieService, EsterniStatiSpecService, User, $q) {

    	var ctrl = this;
    	
    	$scope.enableUser = enableUser;
    	$scope.disableUser = disableUser;
    	$scope.enabled = null;
        
    	if (entity.$promise) {
            entity.$promise.then(function( ent ) {
            	console.log("PROMISE KEPT", ent);
            	if (ent.codiceFiscale) {
                    User.isEnabled({userId : ent.codiceFiscale},function(abilitatoDto){
                    	$scope.enabled = abilitatoDto.flAbilitato;
                    });
            	}
        	}); 
    	} else {
    		console.log("NO PROMISE", entity);
    	}
        
        function enableUser() {
        	User.setEnabled({userId : $scope.esterni.codiceFiscale, flAbilitato: true}, function(){ $scope.enabled = true; });
        }
        
        function disableUser() {
        	User.setEnabled({userId : $scope.esterni.codiceFiscale, flAbilitato: false}, function(){ $scope.enabled = false; });
        }

    	entity.dataNascita = new Date(entity.dataNascita);
    	$scope.esterni = entity;
    	
    	$scope.countryList = null;
    	$scope.genderList = ['M','F'];
    	//Categorie
    	$scope.categoryList = null;
    	getCategorieList();
    	//Stati specifici
    	$scope.statiSpecificiList = null;
    	getStatiSpecificiList();
    	
    	$scope.switchOptions = {
			onText : 'yes',
			offText : 'no', 
			isActive : true,
			size : 'medium',
			animate : true,
			radioOff : true,
			handleWidth : "auto",
			labelWidth : "auto",
			inverse : true,
			onColor : "uniroma",
			offColor : "default",
			switchIsSelected : $scope.esterni.dataFine!=null? true : false
		};
    	
    	$scope.today = new Date();
    	$scope.today.setDate($scope.today.getDate() - 1);
    	$scope.oneYear = new Date()
    	$scope.oneYear.setFullYear($scope.oneYear.getFullYear() + 1);
    	$scope.$watch("esterni.dataAttivazione", function(newStart) {
    	    if (newStart > $scope.esterni.dataFine && $scope.esterni.dataFine != null) {
    	      $scope.esterni.dataFine = newStart;
    	    }
    	}); 
    	$scope.$watch("switchOptions.switchIsSelected", function(newSelected) {
    	    if (!newSelected) {
      	      $scope.esterni.dataFine = null;
    	    } else {
    	    	if ($scope.esterni.dataAttivazione == null) {
    	    		$scope.esterni.dataAttivazione = $scope.today;
    	    	}
    	    	if ($scope.esterni.dataFine == null) {
    	    		$scope.esterni.dataFine = $scope.oneYear;
    	    	}
    	    }
    	}); 
    	
    	Esterni.getCountryList({},function(response){
        	$scope.countryList = response;
        });
    	
    	
    	
    	if($scope.esterni.id != null)
    		$scope.savedCodFis = $scope.esterni.codiceFiscale;
    	else
    		$scope.savedCodFis = null;
       
        $scope.esterniCopy = {};
      
        
        if ( $stateParams.id !== undefined ) {
	        entity.$promise.then(function( ent ) {
	        	//entity.provResidenza = provinciaSelected;
	        	angular.copy(ent, $scope.esterniCopy);
	        });
        }
        
        
        

        $scope.load = function(id) {
            Esterni.get({id : id}, function(result) {
                $scope.esterni = result;
              
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('uniromaLandingApp:esterniUpdate', result);
            $uibModalInstance.close(result);
        };

        var onSaveError = function (result){
        	$window.scrollTo(0, 0);
        }
        
        $scope.save = function () {
            if ($scope.esterni.id != null) {
                Esterni.update($scope.esterni, onSaveFinished, onSaveError);
            } else {
                Esterni.save($scope.esterni, onSaveFinished, onSaveError);
            }
        };
        

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        
        $scope.checkUniqueCodiceFiscale = function(codFis,docIdentita) {
        	var reqObject = {
    			codiceFiscale : codFis,
    			documentoIdentita: docIdentita,
    			nazionalita: $scope.esterni.nazionalita
        	};
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkUniqueCodiceFiscale.check( reqObject, function(resp) {
        		isValid = resp.isUnique;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		//Il codice fiscale esiste perchè è quello dell'utente corrente.
        		else if($scope.savedCodFis != null && $scope.savedCodFis === codfis){
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        
        $scope.checkCodiceFiscale = function(codfis) {
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkCodiceFiscale.check( codfis, function(resp) {
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        $scope.checkDateCodiceFiscale = function(dataNascita, codiceFiscale) {
        	var isValid = false;
        	var deferred = $q.defer();
        	var inputDate =  (dataNascita == null ? new Date() : dataNascita);
        	var payload = {
					"dataNascita": transformDate( inputDate ),
					"codiceFiscale" : codiceFiscale
			}; 
        	CodiceFiscaleService.checkDateCodiceFiscale.check( payload, function(resp) {
        	
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        $scope.checkGenderCodFiscale = function(gender,codiceFiscale){
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(codiceFiscale.length>=10){
        		var giornoNascita = codiceFiscale.substring(9,11);
        		if( (giornoNascita>=40 && gender==='F') || (giornoNascita<40 && gender==='M') ){
        			isValid = true;
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}
        	return deferred.promise;
        };
        
        $scope.isActive = function(){
        	if($scope.esterni!=null && $scope.esterni.flAttivo==1)
        		return true;
        	return false;
        }
          
        
        function transformDate(date) {
        	var formatted = pad(date.getDate(), 2) + "/" + pad(date.getMonth() + 1, 2) + "/" + date.getFullYear();
        	return formatted;
        }
        
        function pad(n, width, z) {
        	z = z || '0';
        	n = n + '';
        	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        ctrl.preventKeyboard = function($event) {
    		$event.preventDefault();
    	}
        
      
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		$scope.categoryList = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        function getStatiSpecificiList(){
        	EsterniStatiSpecService.stati.get({"idEsterno":$scope.esterni.id}, function(resp) {
        		$scope.statiSpecificiList = resp;
        	}, function(err) {
        		deferred.reject(false);
        	});
        };
        
        
}]);
